<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  background-color: #f5f6f8;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;

  background-color: #f0f2f5;
}

.el-button--primary {
    color: #FFF;
    background-color: #c92310;
    border-color: #c92310;
}
.el-button--primary:focus, .el-button--primary:hover {
    background: #d66052 !important;
    border-color: #d66052 !important;
    color: #FFF  !important;
}
.el-button:focus, .el-button:hover {
    color: #c92310;
    border-color: #d66052;
    background-color: #fae9e7;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #FFF;
    background-color: #e9948a  !important;
    border-color: #e9948a  !important;
}

.el-button--text:hover {
    color: #66b1ff;
    border-color: transparent;
    background-color: transparent;
}

.el-button--text:focus, .el-button--text:hover {
    color: #66b1ff;
    border-color: transparent;
    background-color: transparent;
}
/* .red-color-bg-c92310{
  background-color: #c92310;
}
.red-color-border-c92310{
  border-color: #c92310;
}
.red-color-bg-c92310:hover{
  background-color: #d66052;
}
.red-color-border-c92310:hover{
  border-color: #d66052;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue